<template>
  <div class="user">
    <!--导航部分-->
    <div class="nav" style="padding-bottom: 46px;">
      <van-nav-bar
              title="个人中心"
              fixed
              right-text="退出"
              @click-right="onClickRight"
      />
    </div>
    <!--列表-->
    <van-cell-group>
      <van-cell :title="'手机号：'+user.user_info.phone" icon="phone-o" />
    </van-cell-group>
    <van-cell-group>
      <van-cell :title="'姓名：'+user.user_info.name" icon="contact" />
    </van-cell-group>
     <div style="height: 10px;"></div>
    <van-cell-group>
      <van-cell title="我报备的客户" to="/customer" is-link/>
    </van-cell-group>

    <!--导航-->
    <tab-bar :active="2"></tab-bar>

  </div>
</template>

<script>
import TabBar from '../../components/TabBar.vue'
import {mapState,mapActions} from 'vuex'
export default {
    'name': 'User',
    data() {
        return {

        };
    },
    computed: {
        ...mapState({
            user: state => state.user
        })
    },
    methods: {
        ...mapActions(['requestUser','requestLogout']),
        getUserInfo() {
            this.requestUser({"thit":this});
        },
        onClickRight() {
            this.requestLogout({"thit":this});
        }
    },
    mounted () {
        this.getUserInfo();
    },
    components: {
        TabBar
    }
};
</script>

<style scoped>

</style>
